export * from './tenant-picker-item';
export * from './avatar-upload';
export * from './user-details';

import { TenantPickerItemComponent } from './tenant-picker-item';
import { AvatarUploadComponent } from './avatar-upload';
import { UserDetailsComponent } from './user-details';

export const UserDialogMolecules = [
  TenantPickerItemComponent,
  AvatarUploadComponent,
  UserDetailsComponent,
];